import { render, staticRenderFns } from "./KvkkListesi.vue?vue&type=template&id=e62ce0ce&scoped=true&"
import script from "./KvkkListesi.vue?vue&type=script&lang=js&"
export * from "./KvkkListesi.vue?vue&type=script&lang=js&"
import style0 from "./KvkkListesi.vue?vue&type=style&index=0&id=e62ce0ce&lang=scss&scoped=true&"
import style1 from "./KvkkListesi.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./KvkkListesi.vue?vue&type=style&index=2&id=e62ce0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62ce0ce",
  null
  
)

export default component.exports